import { CoursesScreen } from '@/screens/courses-screen/CoursesScreen'

export default function () {
  return <CoursesScreen asTab />
}
